import { createSelector } from "@ngrx/store";

import { AppState } from "./app.state";
import { ShoppingCartDto } from "../core/dtos/dto";

export const selectShoppingCart = createSelector(
  (state: AppState) => state.shoppingCart,
  (shoppingCart: ShoppingCartDto) => shoppingCart
);

export const selectShoppingCartItemCount = createSelector(
  selectShoppingCart,
  (shoppingCart: ShoppingCartDto) => shoppingCart ? shoppingCart.totalProductItemCount : 0
);

export const selectShoppingCartItems = createSelector(
  selectShoppingCart,
  (shoppingCart: ShoppingCartDto) => shoppingCart ? shoppingCart.shoppingCartItems : []
);
